import { cn } from "@utils";
import { CircleAlert } from "lucide-react";
import { useState } from "react";
import { ChangeManagementPlan } from "src/types/change-management";
import { CollapseToggle } from "./CollapseToggle";
import { PlanSection } from "./PlanSection";
import { ReviewActionPlaceholders } from "./ReviewActionPlaceholders";
import { ViewedCheckbox } from "./ViewedCheckbox";

const IssueItem = ({
  issue,
}: {
  issue: ChangeManagementPlan["issues"][number];
}) => {
  const [viewed, setViewed] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <li className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded bg-orange-50 px-4 py-3 text-orange-950">
      <div
        className={cn(
          "flex min-w-0 flex-[1_1_320px] items-start gap-2.5",
          collapsed && "opacity-80"
        )}
      >
        <CircleAlert size={16} className="mt-[3px] shrink-0 text-orange-600" />
        <div className="flex min-w-0 flex-col gap-1 leading-[1.6]">
          <div className="font-semibold">{issue.issue}</div>
          {!collapsed && (
            <>
              <div>{issue.why}</div>
              <div>
                <span className="font-semibold">Next step:</span>{" "}
                {issue.next_step}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-0.5">
        {!collapsed && <ReviewActionPlaceholders showReject compact />}
        <ViewedCheckbox
          checked={viewed}
          onChange={(checked) => {
            setViewed(checked);
            setCollapsed(checked);
          }}
        >
          Viewed
        </ViewedCheckbox>
        <CollapseToggle
          collapsed={collapsed}
          label="issue"
          onToggle={() => setCollapsed(!collapsed)}
        />
      </div>
    </li>
  );
};

export const PlanIssuesCard = ({
  issues,
}: {
  issues: ChangeManagementPlan["issues"];
}) => (
  <PlanSection
    title="Open issues"
    description="Gaps the agent could not resolve."
  >
    <ul className="m-0 flex list-none flex-col gap-2 p-0">
      {issues.map((issue, index) => (
        <IssueItem key={index} issue={issue} />
      ))}
    </ul>
  </PlanSection>
);
